import React from 'react';
import { ToastType } from '@alefeducation/ui-elements-library-core';
import { injectAutoHideToastOfType } from '../../utils/Toast';
import {
  ADMIN_UPDATED_SUCCESSFULLY,
  SOMETHING_WENT_WRONG_MESSAGE,
} from '../../utils/constants';

export const TOAST_ADMIN_ID = 'toast-admin-users-page';
export const AdminToastComponent = () => <div id={TOAST_ADMIN_ID} />;

const error = () => {
  injectAutoHideToastOfType(
    TOAST_ADMIN_ID,
    SOMETHING_WENT_WRONG_MESSAGE,
    ToastType.ERROR,
  );
};

const adminUpdatedSuccessfully = () =>
  injectAutoHideToastOfType(
    TOAST_ADMIN_ID,
    ADMIN_UPDATED_SUCCESSFULLY,
    ToastType.SUCCESS,
  );

const showToast = (message: string, type: ToastType) => {
  injectAutoHideToastOfType(TOAST_ADMIN_ID, message, type);
};

export const AdminToastHelper = {
  error,
  adminUpdatedSuccessfully,
  showToast,
};
